<template>
  <v-row v-if="site.is_use_shortcut_menu" class="pa-0 mt-4">
    <v-col cols="12" class="pa-0">
      <v-window v-model="currentPage">
        <v-window-item
          v-for="(page, pageIndex) in pagedShortcutMenu"
          :key="pageIndex"
        >
          <div class="d-flex px-2 pt-4 pb-2">
            <div
              v-for="(item, index) in page"
              :key="index"
              class="text-center shortcut-item"
            >
              <v-btn
                outlined
                width="64"
                height="64"
                class="pa-0 shortcut-btn"
                style=""
                @mouseenter="onMouseEnter(item, index)"
                @mouseleave="onMouseLeave"
                @click="onClickMenu(item, index)"
              >
                <div
                  :ref="'bubble-content-' + item.name"
                  class="speech-bubble"
                  :class="{ 'is-active': activeIndex === index }"
                  :style="{
                    '--bg-color': site.color,
                    '--font-color': getFontColorBasedOnBg,
                    ...bubbleStyles[item.name],
                  }"
                >
                  <div class="text-truncate">
                    {{ mappingTextMenu(item) }}
                  </div>
                </div>
                <v-badge
                  overlap
                  color="red"
                  dot
                  :value="!!item.noti"
                  offset-x="14"
                  offset-y="14"
                >
                  <div class="box-icon-menu d-flex justify-center align-center">
                    <MenuSymbol
                      position="shortcut_menu"
                      :name="item.name"
                      :type="item.type || 'default'"
                      :symbol="item.symbol || ''"
                      :color="site.color"
                      :is_display="true"
                      :outlined_box="false"
                      :size="36"
                    />
                  </div>
                </v-badge>
              </v-btn>
            </div>
          </div>
        </v-window-item>
      </v-window>
      <div
        v-if="pagedShortcutMenu.length > 1"
        class="d-flex justify-center mt-2"
      >
        <div
          v-for="(page, index) in pagedShortcutMenu"
          :key="index"
          class="mx-1"
          :style="{
            width: '8px',
            height: '8px',
            borderRadius: '50%',
            backgroundColor: currentPage === index ? site.color : '#d0d0d0',
          }"
        />
      </div>
    </v-col>
  </v-row>
</template>

<script>
import MenuSymbol from "./menu/menu-symbol.vue";
import { mapState } from "vuex";
import {
  adjustHslBrightness,
  getFontColorBasedOnBg,
} from "../config/general-function";

export default {
  inject: ["isAppLoading"],
  emits: ["onClose"],
  props: {
    dialog: {
      default: false,
    },
  },
  components: {
    MenuSymbol,
  },
  data() {
    return {
      myDialog: false,
      height: 50, // ความสูงเริ่มต้น 50vh
      isDragging: false,
      startY: 0,
      startHeight: 50,

      currentPage: 0,
      isHoverableDevice: false,
      activeIndex: null,
      activeIndexName: null,
      secondClick: false,
      bubbleStyles: {},
    };
  },
  created() {},
  mounted() {
    window.addEventListener("click", this.onOutsideClick);
    const hoverQuery = window.matchMedia("(hover: hover) and (pointer: fine)");
    this.isHoverableDevice = hoverQuery.matches;
    hoverQuery.addEventListener("change", (e) => {
      this.isHoverableDevice = e.matches;
    });
  },
  beforeDestroy() {
    window.removeEventListener("click", this.onOutsideClick);
  },
  methods: {
    colorDarken(color) {
      let darken = "";
      if (color) {
        darken = adjustHslBrightness(color, -20);
      }
      return darken;
    },
    adjustBubblePosition() {
      this.$nextTick(() => {
        const refs = this.$refs["bubble-content-" + this.activeIndexName];
        const el = Array.isArray(refs) ? refs[0] : refs;
        if (!el) return;

        const rect = el.getBoundingClientRect();
        const padding = 0; // ระยะห่างจากขอบจอขั้นต่ำที่ยอมให้เข้าใกล้
        const screenWidth = window.innerWidth;
        const right = rect.right + 12;
        const left = rect.left - 12;

        // กรณีล้นขอบขวา
        if (right > screenWidth - padding) {
          const overflowRight = right - (screenWidth - padding);
          // สั่งขยับตำแหน่งเข้ามาทางซ้าย
          this.$set(this.bubbleStyles, this.activeIndexName, {
            left: `calc(50% - ${overflowRight}px)`,
            "--arrow-left": `calc(42% + ${overflowRight}px)`,
          });
        }
        // กรณีล้นขอบซ้าย
        else if (left < padding) {
          const overflowLeft = padding - left;
          // สั่งขยับตำแหน่งเข้ามาทางขวา
          this.$set(this.bubbleStyles, this.activeIndexName, {
            left: `calc(50% + ${overflowLeft}px)`,
            "--arrow-left": `calc(42% - ${overflowLeft}px)`,
          });
        }
      });
    },

    mappingTextMenu(param) {
      let label = param.name;
      const mapping = {
        main: "home",
        mission: "activity",
        reward: "reward",
        transport: "tracking",
        account: "account",
        // Extend
        chat: { name: "menuChatRoom", route: "chat-room" },
        report: { name: "menuInformationCenter", route: "report" },
        campaign: { name: "menuCampaign", route: "campaign" },
        request: { name: "menuRequest", route: "request" },
        warranty: { name: "menuWarranty", route: "warranty" },
        other: { name: "other", route: "other" },
      };
      if (mapping[param.name]) {
        label = this.$t(mapping[param.name]?.name || mapping[param.name]);
      }
      return label;
    },

    onOutsideClick(e) {
      if (!e.target.closest(".shortcut-btn")) {
        this.activeIndex = null;
        this.activeIndexName = null
      }
    },
    onMouseEnter(param, index) {
      if (this.isHoverableDevice) {
        this.activeIndex = index;
        this.activeIndexName = param.name;
      }
    },
    onMouseLeave() {
      if (this.isHoverableDevice) {
        this.activeIndex = null;
      }
    },
    onClickMenu(param, index) {
      if (!this.isHoverableDevice) {
        if (this.activeIndex != index) {
          this.secondClick = false;
        } else {
          this.secondClick = true;
        }
        this.activeIndex = index;
        this.activeIndexName = param.name;
        if (!this.secondClick) {
          return;
        }
      }
      const mapping = {
        mission: { name: "activity", route_name: "mission" },
        reward: { name: "reward", route_name: "reward" },
        transport: { name: "transport", route_name: "transport" },
        account: { name: "account", route_name: "my-account" },
        chat: { name: "menuChatRoom", route_name: "chat-room-list" },
        report: {
          name: "menuInformationCenter",
          route_name: "information-center-list",
        },
        campaign: { name: "menuCampaign", route_name: "campaign-list" },
        request: { name: "menuRequest", route_name: "request-list" },
        warranty: { name: "menuWarranty", route_name: "warranty-list" },
      };
      if (mapping[param?.name]) {
        const curName = this.$router.currentRoute.name;
        const routerName = mapping[param?.name].route_name;
        if (curName != routerName) {
          this.isAppLoading(true);
          this.$router
            .push({
              name: routerName,
            })
            .then(() => {
              if (["transport"].includes(routerName)) {
                this.isAppLoading(false);
              }
            });
        }
      }
    },
  },
  computed: {
    ...mapState("defaultSystem", ["site", "notificationData"]),
    shortcutMenu() {
      let list = [];
      if (this.site?.shortcut_menu?.menu?.length > 0) {
        list = this.site?.shortcut_menu?.menu;
      }
      const icon_menu = this.site?.icon_menu?.menu || [];
      for (let item of list) {
        if (item.name == "report") {
          item.noti = this.notificationData.report_admin || false;
        } else if (item.name == "request") {
          item.noti = this.notificationData.report_user || false;
        } else if (item.name == "warranty") {
          item.noti = this.notificationData.report_user_warranty || false;
        }
        const model = icon_menu.find((x) => x.name == item.name);
        if (model) {
          item.type = model.type;
          item.symbol = model.symbol;
        }
      }
      return list;
    },
    pagedShortcutMenu() {
      const size = this.$vuetify.breakpoint.width >= 720 ? 15 : 5;
      return this.shortcutMenu.reduce((pages, item, index) => {
        const pageIndex = Math.floor(index / size);
        if (!pages[pageIndex]) {
          pages[pageIndex] = [];
        }
        pages[pageIndex].push(item);

        return pages;
      }, []);
    },
    getFontColorBasedOnBg() {
      const res = getFontColorBasedOnBg(this.site.color, "bw");
      return res;
    },
  },
  watch: {
    currentPage: {
      handler() {
        this.activeIndex = null;
        this.activeIndexName = null
      },
    },
    activeIndex: {
      handler() {
        if (this.activeIndex >= 0) {
          this.adjustBubblePosition();
        }
      },
    },
  },
};
</script>

<style scoped>
::v-deep .v-btn__content {
  width: 100%;
  flex-direction: column;
}
.float-panel-btn {
  width: 100px;
  height: 80px !important;
  border-radius: 12px;
  background-color: #ffffff !important;
}
.description-label {
  line-height: 1.3;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

/* Menu Top Bar */
.box-icon-menu {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  /* border: 1px solid #616161; */
}
.box-title-menu {
  /* max-width: calc(100% - 8px); */
  width: 50px;
  height: 40px;
  font-size: 10px;
  padding-top: 4px;
  /* text-overflow: ellipsis;
  white-space: break-spaces; */
  /* line-height: 1.7; */
  white-space: break-spaces;
  /* overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical; */
}

.speech-bubble {
  position: absolute;
  bottom: 60%;
  left: 50%;
  z-index: 1;
  margin-bottom: 6px;
  padding: 4px 12px;

  background-color: var(--bg-color, #000000);
  color: var(--font-color, #ffffff);

  border-radius: 18px;
  white-space: nowrap;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  pointer-events: none;

  opacity: 0;
  visibility: hidden;
  transform: translateX(-50%) translateY(4px) scale(0.8);
  transition: all 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.speech-bubble.is-active {
  opacity: 1;
  visibility: visible;
  transform: translateX(-50%) translateY(-6px) scale(1);
}

/* หางสามเหลี่ยม */
.speech-bubble::after {
  content: "";
  position: absolute;
  top: 100%;
  left: var(--arrow-left, 42%);
  border-width: 6px;
  border-style: solid;
  border-color: var(--bg-color, #000000) transparent transparent transparent;
}

.shortcut-btn {
  position: relative;
  min-width: 64px;
  border-width: 0;
  border-radius: 50%;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  background: #ffffff;
}

.shortcut-item {
  flex: 0 0 20%;
  max-width: 20%;
}

@media (min-width: 720px) {
  .shortcut-item {
    flex: 0 0 10%;
    max-width: 10%;
  }
}
@media (min-width: 1024px) {
  .shortcut-item {
    flex: 0 0 8.666%;
    max-width: 8.666%;
  }
}
@media (min-width: 1440px) {
  .shortcut-item {
    flex: 0 0 6%;
    max-width: 6%;
  }
}
</style>
